import { SideNavInterface } from '../../interfaces/side-nav.type';

export const ROUTES: SideNavInterface[] = [
  {
    path: '/home',
    title: 'Home',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'home',
    submenu: []
  },
  {
    path: '/stores',
    title: 'Stores',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'appstore',
    submenu: [
    ]
  },
  {
    path: '/orders',
    title: 'Orders',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'schedule',
    submenu: [
    ]
  },
  {
    path: '/users',
    title: 'Users',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'user',
    submenu: [
    ]
  },
  {
    path: '/links',
    title: 'Links',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'cloud',
    submenu: [
    ]
  },{
    path: '/alerts',
    title: 'Alerts',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'alert',
    submenu: [
    ]
  },{
    path: '/messages',
    title: 'Messages',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'inbox',
    submenu: [
    ]
  },{
    path: '/documents',
    title: 'Documents',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'file',
    submenu: [
    ]
  },{
    path: '/activities',
    title: 'Activities',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'file-image',
    submenu: [
    ]
  },{
    path: '/settings',
    title: 'Settings',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'setting',
    submenu: [
    ]
  }
]
